import { useAppDispatch, useAppSelector } from 'redux/hooks';

import { useDroppable } from '@dnd-kit/core';
import { useFeatureFlags } from 'features/feature-flags/hooks/use-feature-flags';
import { setRecReviewTab } from 'features/my-view/redux/my-view-slice';
import { selectRecReviewTab } from 'features/my-view/redux/selectors';
import { Link } from 'react-router-dom';
import { getTabItems } from '../config';

export const Tabs = () => {
	const dispatch = useAppDispatch();
	const activeTab = useAppSelector(selectRecReviewTab);
	const { flags } = useFeatureFlags();

	// Check if room type rates tab should be shown (defaults to false)
	const showRoomTypeRatesTab = flags?.roomTypeRatesTab?.enabled ?? false;
	const tabItems = getTabItems(showRoomTypeRatesTab);

	const onTabClick = (key: string) => {
		dispatch(setRecReviewTab(key));
	};
	const {
		isOver,
		setNodeRef,
		active: dragActive,
	} = useDroppable({
		id: 'metrics-tab',
	});

	return (
		<div className='dashboard__tabs'>
			{tabItems.map((tab, _idx) => {
				const droppable =
					dragActive && dragActive.data.current?.action === 'add';

				const classes: string[] = [
					`dashboard__tab dashboard__tab-${tab.class}`,
				];
				if (activeTab && activeTab === tab.key)
					classes.push('dashboard__tab-activeTab');
				if (tab.key === 'metrics' && droppable) {
					classes.push('dashboard__tab-droppable');
					if (isOver) classes.push('dashboard__tab-drop-target');
				}

				return (
					<div
						className={classes.join(' ')}
						key={tab.key}
						ref={tab.key === 'metrics' ? setNodeRef : null}
					>
						<Link
							to={`${tab.to}`}
							onClick={() => {
								onTabClick(tab.key);
							}}
						>
							{tab.title}
						</Link>
					</div>
				);
			})}
		</div>
	);
};
